import { Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { AuthGuard } from '@next/core-lib/authorization';

import { ActiveIngredientSettingsComponent } from './activeingredientsetting/components/activeingredientsetting/activeingredientsetting.component';
import { CropSettingsComponent } from './cropsetting/components/cropsetting/cropsetting.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/cropsettings',
    pathMatch: 'full',
  },
  {
    path: 'cropsettings',
    component: CropSettingsComponent,
    canActivate: [AuthGuard],
    data: {
      pageTitle: 'cropSettings',
    },
  },
  {
    path: 'activeingredientsettings',
    component: ActiveIngredientSettingsComponent,
    canActivate: [AuthGuard],
    data: {
      pageTitle: 'activeIngredientSettings',
    },
  },
  ...coreRoutes,
];
